import { NgModule } from '@angular/core';
import { PHBHPHeaderComponent } from './ph-bhp-header/ph-bhp-header.component';
import { LayoutComponent } from './ph-bhp-layout/layout.component';
import { PHBHPNavbarComponent } from './ph-bhp-navbar/ph-bhp-navbar.component';
import { PhBhpUserMenuComponent } from './ph-bhp-user-menu/ph-bhp-user-menu.component';
import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';
import { ClientLibModule } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';
import { PHBHPFeaturePackageCheckModule } from '../check/hygiene-check-package.module';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { TooltipModule as BsTooltipModule } from 'ngx-bootstrap/tooltip';
import { ProfileModule } from 'profile';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module';
import { MatIconModule } from '@angular/material/icon';
import { PhBhpFeatureComponentsModule } from 'ph-bhp-feature-packages/ph-bhp-feature-components/public_api';

// common libraries


@NgModule({
  declarations: [
    PHBHPHeaderComponent,
    LayoutComponent,
    PHBHPNavbarComponent,
    PhBhpUserMenuComponent
  ],
  imports: [
    PHBHPLayoutPackageModule,
    PHBHPLocalizePackageModule,
    TooltipModule,
    ProfileModule,
    BsTooltipModule.forRoot(),
    PhBhpUiModule,
    MatIconModule,
    ClientLibModule,
    PHBHPFeaturePackageCheckModule,
    PhBhpFeatureComponentsModule
  ],
  //exports: [LayoutComponent ]
})
export class LayoutModule {}
